

const IMDB_TITLE_URL = 'https://www.imdb.com/title';

export {
  IMDB_TITLE_URL
};
